import {
    createJustText,
    IJustTextProperties,
    JustText,
} from '@vfde-brix/ws10/just-text';
import { IPatternWithNoPatternBusinessLogic } from '@vfde-brix/ws10/core';

/**
 * Mount text
 */
export default function mountText (
    id: string,
    properties: IJustTextProperties | IPatternWithNoPatternBusinessLogic,
    dom = document,
): JustText | null {
    const container = dom.getElementById(id);

    return container && createJustText(container, properties);
}
